import logo from '../../../../assets/logos/aye-logo.png'

export default function RegisterPageTopSection() {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <img src={logo} alt="Aye Logo" width={'45%'} height={'100%'} />
        <p className="text-md pb-3 pt-8 text-center">
          Experience The Future of Payments
        </p>
      </div>
      <div className="flex flex-col items-center justify-center">
        <p className="text-center text-[2.2rem] font-bold">
          Start Paying with Your Face
          <br /> Today
        </p>
      </div>
    </div>
  )
}
